import React from 'react';
import { useStore } from '../../../store/state';
import { SelfBillTerms } from '../SelfBillTerms/SelfBillTerms';
import { useSelfBillTerms } from '../SelfBillTerms/useSelfBillTerms';
export const AgentModalWrapper: React.FC = ({ children }) => {
  const [{ userState }] = useStore();
  const { isSelfBillModalOpen, ...selfbillProps } = useSelfBillTerms(
    userState.agent.agencyId ?? '',
    'agency'
  );
  return (
    <>
      <SelfBillTerms isOpen={isSelfBillModalOpen} {...selfbillProps} />
      {children}
    </>
  );
};
